var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modalEdit24TVUser",attrs:{"id":"modalEdit24TVUser","title":_vm.$t('modalEdit24TVUser'),"hide-footer":"","size":"xl"},on:{"shown":_vm.shown}},[_c('subs',{attrs:{"userInfo":_vm.userInfo}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-529ba144","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/customerPortal/24tv/userInfo.vue
// module id = null
// module chunks = 